import {Component} from '@angular/core';

@Component({
  selector: 'app-component-404',
  imports: [],
  templateUrl: './component-404.component.html',
  styleUrl: './component-404.component.scss'
})
export class Component404 {

}
